import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { QuestionsViewersEngagedLoadAction } from '../../domains/questionsViewersEngaged/actions.types';

import { QuestionsViewersEngagedLifecycle } from './types';

const initialState: QuestionsViewersEngagedLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<QuestionsViewersEngagedLifecycle, QuestionsViewersEngagedLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'QUESTIONS_VIEWERS_ENGAGED.LOAD_PENDING':
      return setPending();
    case 'QUESTIONS_VIEWERS_ENGAGED.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.questionsViewersEngaged);
    case 'QUESTIONS_VIEWERS_ENGAGED.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
